import { LinkContent } from "../../../LinkDataInterface";
import {
  faBook,
  faCodeBranch,
  faInbox,
  faMap,
  faDoorOpen,
  faUserSecret,
  faHouseFire,
  faWalkieTalkie,
  faFileWaveform,
  faPersonMilitaryPointing,
  faCompassDrafting,
  faCircleInfo,
  faFingerprint,
  faClipboardUser,
  faChampagneGlasses,
  faCalendar,
  faClock,
  faPeopleRoof,
  faUsersRectangle,
  faVestPatches,
  faPlaneDeparture,
  faBuildingColumns,
  faIdBadge,
  faUserCheck,
  faFileShield,
} from "@fortawesome/free-solid-svg-icons";

export const folderSecurity: LinkContent = {
  faLogo: faUserSecret,
  title: "Sécurité 2025",
  link: "https://drive.google.com/drive/folders/1vgGZIaxi04xm7njVTiXOSHHLaIzBTC5Z?usp=drive_link",
};
export const folderPC: LinkContent = {
  faLogo: faWalkieTalkie,
  title: "PC 2025",
  link: "https://drive.google.com/drive/folders/1we9hV6bjPL2zxF4hmCkU2oarpor_swAt?usp=drive_link",
};
export const folderDynamic: LinkContent = {
  faLogo: faFileWaveform,
  title: "Document dynamique 2025",
  link: "https://drive.google.com/drive/folders/1DKQ3bZQIHPHvBe0OanFbuaDma5GclQhA?usp=drive_link",
};
export const docDesPortes: LinkContent = {
  faLogo: faDoorOpen,
  title: "DocDesPortes 2025",
  link: "https://docs.google.com/spreadsheets/d/1CnyOAgW8hOfY9BCEqcHKRFIX0S3qpOABxCc1Z-BKUwQ/edit?gid=1654185270#gid=1654185270",
};
export const devisAgent: LinkContent = {
  faLogo: faPersonMilitaryPointing,
  title: "Agents devis",
  link: "https://docs.google.com/spreadsheets/d/1GFxfqbNdaIS60wC7Ox6AS5usykjw03sQhfXY3hU4otM/edit?gid=383989133#gid=383989133",
};
export const emergencyUsage: LinkContent = {
  faLogo: faHouseFire,
  title: "Procédures d'urgence 2025",
  link: "https://docs.google.com/document/d/1KMjkKjEWBYkiXmcRXuy-SjvxVvtZ-L41aV_BmiajV7g/edit?tab=t.0#heading=h.61pr268c4geg",
};
export const emergencyDoc: LinkContent = {
  faLogo: faFileShield,
  title: "Théorie urgence 2025",
  link: "https://docs.google.com/document/d/1KMjkKjEWBYkiXmcRXuy-SjvxVvtZ-L41aV_BmiajV7g/edit?tab=t.0#heading=h.61pr268c4geg",
};
export const besoinTech: LinkContent = {
  faLogo: faCompassDrafting,
  title: "Besoin tech 2025",
  link: "https://docs.google.com/spreadsheets/d/17ch8wzdyUFPrmCQmApV8uxjVikgqbaPfndpUpmlo4cw/edit?usp=drive_link",
};
export const posteGeneral: LinkContent = {
  faLogo: faCircleInfo,
  title: "Fiche Générale 2025",
  link: "https://docs.google.com/document/d/1yRX0nF3kTfSY6WOkOE2B6V1GnU5-le23CkQ-sSf-7vk/edit?usp=drive_link",
};
export const posteAgent: LinkContent = {
  faLogo: faFingerprint,
  title: "Fiche Agent 2025",
  link: "https://docs.google.com/document/d/1Z4o-4v-EQ07rz3OqwWLP2HBmviQbWshfzqmWlInM5Ug/edit?usp=drive_link",
};
export const posteStaffs: LinkContent = {
  faLogo: faClipboardUser,
  title: "Fiche Staff 2025",
  link: "https://docs.google.com/document/d/1gcU4Pw0PYiWDdtxTOukdDRvCFUHpK-KA-WSHgoUe60I/edit?usp=drive_link",
};
export const suiviAnim: LinkContent = {
  faLogo: faChampagneGlasses,
  title: "Suivit anim 2025",
  link: "https://docs.google.com/spreadsheets/d/1JMKAtS1XHF3TmxWlMiXpO8y49VCdJiQ2I_h9Wt5JSeM/edit?usp=drive_link",
};
export const planningParSalle: LinkContent = {
  faLogo: faCalendar,
  title: "Planning par salle 2025",
  link: "https://docs.google.com/spreadsheets/d/1zPvOlNxeeUGqXWCFNCVii8PRf8-GptVn3wUSrjof5EQ/edit?gid=667219911#gid=667219911",
};
export const hoursSheet: LinkContent = {
  faLogo: faClock,
  title: "Doc des heures 2025",
  link: "https://docs.google.com/spreadsheets/d/1_FxzacZEScFIqM5meuTClzd6AC4e7aIB74QesGsMEck/edit?gid=0#gid=0",
};
export const listComity: LinkContent = {
  faLogo: faPeopleRoof,
  title: "Liste comité 2025",
  link: "https://docs.google.com/spreadsheets/d/1nPYuJHwAOTNvEPgIGvzBXoQI1dk_GO1nMrtoMPERE-A/edit?usp=drive_link",
};
export const odjPleniaire: LinkContent = {
  faLogo: faUsersRectangle,
  title: "OdJ Pléniaire 2025",
  link: "https://herminesnow.ch",
};

export const odjTech: LinkContent = {
  faLogo: faVestPatches,
  title: "OdJ Technique 2025",
  link: "https://docs.google.com/document/d/1K5nrt_UdH8HhahBfw5FEGSdwX0JeTRhYQ-AjAZZ-h5k/edit?tab=t.0#heading=h.hnbpct4sms45",
};

export const odjAnim: LinkContent = {
  faLogo: faPlaneDeparture,
  title: "OdJ Animation 2025",
  link: "https://docs.google.com/document/d/1l3xhVW8tvurLFkAhFqXjWTkin8P3ApvsuKxn4pyLJ8Y/edit?tab=t.0",
};
export const odjPresidence: LinkContent = {
  faLogo: faBuildingColumns,
  title: "OdJ Présidence 2025",
  link: "https://docs.google.com/document/d/1DNntUKi4Y0yGI-3sPCvYfp2EkHuhaN6mM8VKwlVyN1c/edit?tab=t.0#heading=h.a0mtuqnwfkue",
};

export const accreds: LinkContent = {
  faLogo: faIdBadge,
  title: "Accreds",
  link: "https://accreds.japan-impact.ch/",
};
export const standsValidator: LinkContent = {
  faLogo: faUserCheck,
  title: "Validateur stand",
  link: "https://herminesnow.ch",
};

export const planningComite: LinkContent = {
  faLogo: faUserCheck,
  title: "Planning comité 2025",
  link: "https://docs.google.com/spreadsheets/d/1lYTjktU4tAFv6qQsTqHyJ9fbbt3u0BalVeSwCeiaqh8/edit?gid=719862064#gid=719862064",
};

export const mail: LinkContent = {
  faLogo: faInbox,
  title: "Mail",
  link: "https://mail.google.com/mail/u/0/#inbox",
};
export const cartographe: LinkContent = {
  faLogo: faMap,
  title: "Cartographe",
  link: "https://cartographe.japan-impact.ch/",
};

export const github: LinkContent = {
  faLogo: faCodeBranch,
  title: "GitHub",
  link: "https://github.com/Polyjapan",
};

export const wiki: LinkContent = {
  faLogo: faBook,
  title: "Wiki",
  link: "https://wiki.japan-impact.ch/",
};
